import {createListSearchOrderItem, ListSearchOrderByItem, orderByAlphabetPipe} from "orpyx-web-common";
import {GetPatientsListPropertyOrderBy} from "admins-dashboard/http-clients/index";

const orderByDatePipe = (message: string, orderByAsc?: boolean): string =>
    `${message} (${orderByAsc ? 'oldest first' : 'newest first'})`;

export const PatientsListOrderPipe = (order: GetPatientsListPropertyOrderBy, orderByAsc?: boolean): string => {
    switch (order) {
        case GetPatientsListPropertyOrderBy.PatientId:
            return 'Orpyx ID';
        case GetPatientsListPropertyOrderBy.FirstName:
            return orderByAlphabetPipe('First name', orderByAsc);
        case GetPatientsListPropertyOrderBy.LastName:
            return orderByAlphabetPipe('Last name', orderByAsc);
        case GetPatientsListPropertyOrderBy.NamesPair:
            return orderByAlphabetPipe('Full name', orderByAsc);
        case GetPatientsListPropertyOrderBy.ClientPatientIdentifier:
            return 'Patient ID';
        case GetPatientsListPropertyOrderBy.CreatedAt:
            return 'Created at';
        case GetPatientsListPropertyOrderBy.Organization:
            return 'Organization';
        case GetPatientsListPropertyOrderBy.Deleted:
            return 'Deleted';
        case GetPatientsListPropertyOrderBy.Status:
            return 'Status';
        case GetPatientsListPropertyOrderBy.LastStatusUpdatedAt:
            return orderByDatePipe('Status last changed', orderByAsc);
    }
    return `Unknown: ${order}`;
};

export const PatientsListOrderPipeItems: ListSearchOrderByItem[] = [
    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.PatientId, PatientsListOrderPipe),

    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.FirstName, PatientsListOrderPipe, true),
    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.FirstName, PatientsListOrderPipe, false),

    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.LastName, PatientsListOrderPipe, true),
    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.LastName, PatientsListOrderPipe, false),

    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.NamesPair, PatientsListOrderPipe, true),
    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.NamesPair, PatientsListOrderPipe, false),

    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.ClientPatientIdentifier, PatientsListOrderPipe),
    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.Organization, PatientsListOrderPipe),
    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.CreatedAt, PatientsListOrderPipe),
    createListSearchOrderItem<GetPatientsListPropertyOrderBy>(GetPatientsListPropertyOrderBy.Deleted, PatientsListOrderPipe),
];
